export const AppDownloadQrCodeSvg = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1126 1126" {...props}>
    <g shapeRendering="crispEdges">
      <path fill="#fff" d="M0 0h1126v1126H0z" />
      <path
        fill="#0d4029"
        d="M70 70h34v34H70zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#fff"
        d="M308 70h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#0d4029"
        d="M410 70h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M512 70h34v34h-34z" />
      <path fill="#0d4029" d="M546 70h34v34h-34z" />
      <path
        fill="#fff"
        d="M580 70h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M682 70h34v34h-34z" />
      <path
        fill="#fff"
        d="M716 70h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#0d4029"
        d="M818 70h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zM70 104h34v34H70z"
      />
      <path
        fill="#fff"
        d="M104 104h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M274 104h34v34h-34z" />
      <path fill="#fff" d="M308 104h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M376 104h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M444 104h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M512 104h34v34h-34z" />
      <path
        fill="#fff"
        d="M546 104h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M682 104h34v34h-34z" />
      <path
        fill="#fff"
        d="M716 104h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M818 104h34v34h-34z" />
      <path
        fill="#fff"
        d="M852 104h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M1022 104h34v34h-34zM70 138h34v34H70z" />
      <path fill="#fff" d="M104 138h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M138 138h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M240 138h34v34h-34z" />
      <path fill="#0d4029" d="M274 138h34v34h-34z" />
      <path
        fill="#fff"
        d="M308 138h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M444 138h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#fff"
        d="M512 138h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M750 138h34v34h-34z" />
      <path fill="#fff" d="M784 138h34v34h-34z" />
      <path fill="#0d4029" d="M818 138h34v34h-34z" />
      <path fill="#fff" d="M852 138h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M886 138h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M988 138h34v34h-34z" />
      <path fill="#0d4029" d="M1022 138h34v34h-34zM70 172h34v34H70z" />
      <path fill="#fff" d="M104 172h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M138 172h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M240 172h34v34h-34z" />
      <path fill="#0d4029" d="M274 172h34v34h-34z" />
      <path fill="#fff" d="M308 172h34v34h-34z" />
      <path fill="#0d4029" d="M342 172h34v34h-34z" />
      <path
        fill="#fff"
        d="M376 172h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#0d4029"
        d="M478 172h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M580 172h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M648 172h34v34h-34z" />
      <path fill="#fff" d="M682 172h34v34h-34z" />
      <path fill="#0d4029" d="M716 172h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M784 172h34v34h-34z" />
      <path fill="#0d4029" d="M818 172h34v34h-34z" />
      <path fill="#fff" d="M852 172h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M886 172h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M988 172h34v34h-34z" />
      <path fill="#0d4029" d="M1022 172h34v34h-34zM70 206h34v34H70z" />
      <path fill="#fff" d="M104 206h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M138 206h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M240 206h34v34h-34z" />
      <path fill="#0d4029" d="M274 206h34v34h-34z" />
      <path fill="#fff" d="M308 206h34v34h-34z" />
      <path fill="#0d4029" d="M342 206h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M410 206h34v34h-34z" />
      <path fill="#0d4029" d="M444 206h34v34h-34z" />
      <path fill="#fff" d="M478 206h34v34h-34z" />
      <path fill="#0d4029" d="M512 206h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M580 206h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M614 206h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M784 206h34v34h-34z" />
      <path fill="#0d4029" d="M818 206h34v34h-34z" />
      <path fill="#fff" d="M852 206h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M886 206h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M988 206h34v34h-34z" />
      <path fill="#0d4029" d="M1022 206h34v34h-34zM70 240h34v34H70z" />
      <path
        fill="#fff"
        d="M104 240h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M274 240h34v34h-34z" />
      <path
        fill="#fff"
        d="M308 240h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M648 240h34v34h-34z" />
      <path fill="#fff" d="M682 240h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M750 240h34v34h-34z" />
      <path fill="#fff" d="M784 240h34v34h-34z" />
      <path fill="#0d4029" d="M818 240h34v34h-34z" />
      <path
        fill="#fff"
        d="M852 240h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#0d4029"
        d="M1022 240h34v34h-34zM70 274h34v34H70zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M308 274h34v34h-34z" />
      <path fill="#0d4029" d="M342 274h34v34h-34z" />
      <path fill="#fff" d="M376 274h34v34h-34z" />
      <path fill="#0d4029" d="M410 274h34v34h-34z" />
      <path fill="#fff" d="M444 274h34v34h-34z" />
      <path fill="#0d4029" d="M478 274h34v34h-34z" />
      <path fill="#fff" d="M512 274h34v34h-34z" />
      <path fill="#0d4029" d="M546 274h34v34h-34z" />
      <path fill="#fff" d="M580 274h34v34h-34z" />
      <path fill="#0d4029" d="M614 274h34v34h-34z" />
      <path fill="#fff" d="M648 274h34v34h-34z" />
      <path fill="#0d4029" d="M682 274h34v34h-34z" />
      <path fill="#fff" d="M716 274h34v34h-34z" />
      <path fill="#0d4029" d="M750 274h34v34h-34z" />
      <path fill="#fff" d="M784 274h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M818 274h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#fff"
        d="M70 308h34v34H70zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M410 308h34v34h-34z" />
      <path
        fill="#fff"
        d="M444 308h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M546 308h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M614 308h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M682 308h34v34h-34z" />
      <path fill="#fff" d="M716 308h34v34h-34z" />
      <path fill="#0d4029" d="M750 308h34v34h-34z" />
      <path
        fill="#fff"
        d="M784 308h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M70 342h34v34H70zm34 0h34v34h-34z" />
      <path
        fill="#fff"
        d="M138 342h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#0d4029"
        d="M240 342h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M342 342h34v34h-34z" />
      <path fill="#0d4029" d="M376 342h34v34h-34z" />
      <path fill="#fff" d="M410 342h34v34h-34z" />
      <path fill="#0d4029" d="M444 342h34v34h-34z" />
      <path fill="#fff" d="M478 342h34v34h-34z" />
      <path fill="#0d4029" d="M512 342h34v34h-34z" />
      <path fill="#fff" d="M546 342h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M580 342h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#fff"
        d="M682 342h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M886 342h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#fff"
        d="M954 342h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zM70 376h34v34H70z"
      />
      <path
        fill="#0d4029"
        d="M104 376h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#fff"
        d="M274 376h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M376 376h34v34h-34z" />
      <path fill="#fff" d="M410 376h34v34h-34z" />
      <path fill="#0d4029" d="M444 376h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M512 376h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M580 376h34v34h-34z" />
      <path fill="#fff" d="M614 376h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M648 376h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#fff"
        d="M750 376h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M852 376h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M920 376h34v34h-34z" />
      <path fill="#0d4029" d="M954 376h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M1022 376h34v34h-34z" />
      <path fill="#0d4029" d="M70 410h34v34H70z" />
      <path fill="#fff" d="M104 410h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M172 410h34v34h-34z" />
      <path fill="#fff" d="M206 410h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M240 410h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M376 410h34v34h-34z" />
      <path fill="#0d4029" d="M410 410h34v34h-34z" />
      <path fill="#fff" d="M444 410h34v34h-34z" />
      <path fill="#0d4029" d="M478 410h34v34h-34z" />
      <path fill="#fff" d="M512 410h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M580 410h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#fff"
        d="M716 410h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M852 410h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#fff"
        d="M920 410h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zM70 444h34v34H70zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M138 444h34v34h-34z" />
      <path fill="#fff" d="M172 444h34v34h-34z" />
      <path fill="#0d4029" d="M206 444h34v34h-34z" />
      <path
        fill="#fff"
        d="M240 444h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M342 444h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M410 444h34v34h-34z" />
      <path fill="#0d4029" d="M444 444h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M512 444h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M580 444h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M648 444h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M716 444h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M818 444h34v34h-34z" />
      <path fill="#0d4029" d="M852 444h34v34h-34z" />
      <path fill="#fff" d="M886 444h34v34h-34z" />
      <path fill="#0d4029" d="M920 444h34v34h-34z" />
      <path
        fill="#fff"
        d="M954 444h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zM70 478h34v34H70z"
      />
      <path fill="#0d4029" d="M104 478h34v34h-34z" />
      <path
        fill="#fff"
        d="M138 478h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M240 478h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M308 478h34v34h-34z" />
      <path fill="#0d4029" d="M342 478h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M410 478h34v34h-34z" />
      <path fill="#0d4029" d="M444 478h34v34h-34z" />
      <path
        fill="#fff"
        d="M478 478h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M614 478h34v34h-34z" />
      <path fill="#fff" d="M648 478h34v34h-34z" />
      <path fill="#0d4029" d="M682 478h34v34h-34z" />
      <path fill="#fff" d="M716 478h34v34h-34z" />
      <path fill="#0d4029" d="M750 478h34v34h-34z" />
      <path fill="#fff" d="M784 478h34v34h-34z" />
      <path fill="#0d4029" d="M818 478h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#fff"
        d="M886 478h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M1022 478h34v34h-34z" />
      <path fill="#fff" d="M70 512h34v34H70zm34 0h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M138 512h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M240 512h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M308 512h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M376 512h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M444 512h34v34h-34z" />
      <path fill="#fff" d="M478 512h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M546 512h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M614 512h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M648 512h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M784 512h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M818 512h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M920 512h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M988 512h34v34h-34zm34 0h34v34h-34zM70 546h34v34H70z"
      />
      <path fill="#fff" d="M104 546h34v34h-34z" />
      <path fill="#0d4029" d="M138 546h34v34h-34z" />
      <path fill="#fff" d="M172 546h34v34h-34z" />
      <path fill="#0d4029" d="M206 546h34v34h-34z" />
      <path fill="#fff" d="M240 546h34v34h-34z" />
      <path fill="#0d4029" d="M274 546h34v34h-34z" />
      <path fill="#fff" d="M308 546h34v34h-34z" />
      <path fill="#0d4029" d="M342 546h34v34h-34z" />
      <path fill="#fff" d="M376 546h34v34h-34z" />
      <path fill="#0d4029" d="M410 546h34v34h-34z" />
      <path
        fill="#fff"
        d="M444 546h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M546 546h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M614 546h34v34h-34z" />
      <path fill="#0d4029" d="M648 546h34v34h-34z" />
      <path fill="#fff" d="M682 546h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M750 546h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M818 546h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M852 546h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M988 546h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M70 580h34v34H70zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#fff"
        d="M206 580h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M342 580h34v34h-34z" />
      <path
        fill="#fff"
        d="M376 580h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M478 580h34v34h-34z" />
      <path fill="#fff" d="M512 580h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M546 580h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M648 580h34v34h-34z" />
      <path fill="#0d4029" d="M682 580h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#fff"
        d="M750 580h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M954 580h34v34h-34z" />
      <path fill="#fff" d="M988 580h34v34h-34z" />
      <path fill="#0d4029" d="M1022 580h34v34h-34zM70 614h34v34H70z" />
      <path fill="#fff" d="M104 614h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M172 614h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M240 614h34v34h-34z" />
      <path fill="#0d4029" d="M274 614h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#fff"
        d="M342 614h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#0d4029"
        d="M512 614h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M682 614h34v34h-34z" />
      <path fill="#0d4029" d="M716 614h34v34h-34z" />
      <path
        fill="#fff"
        d="M750 614h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M920 614h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M988 614h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M70 648h34v34H70zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M206 648h34v34h-34z" />
      <path fill="#0d4029" d="M240 648h34v34h-34z" />
      <path
        fill="#fff"
        d="M274 648h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M376 648h34v34h-34z" />
      <path fill="#fff" d="M410 648h34v34h-34z" />
      <path fill="#0d4029" d="M444 648h34v34h-34z" />
      <path fill="#fff" d="M478 648h34v34h-34z" />
      <path fill="#0d4029" d="M512 648h34v34h-34z" />
      <path fill="#fff" d="M546 648h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M614 648h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M784 648h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M818 648h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M920 648h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M954 648h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zM70 682h34v34H70zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M138 682h34v34h-34z" />
      <path fill="#0d4029" d="M172 682h34v34h-34z" />
      <path fill="#fff" d="M206 682h34v34h-34z" />
      <path fill="#0d4029" d="M240 682h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M308 682h34v34h-34z" />
      <path fill="#0d4029" d="M342 682h34v34h-34z" />
      <path fill="#fff" d="M376 682h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M444 682h34v34h-34z" />
      <path fill="#fff" d="M478 682h34v34h-34z" />
      <path fill="#0d4029" d="M512 682h34v34h-34z" />
      <path fill="#fff" d="M546 682h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M580 682h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M682 682h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M716 682h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M954 682h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M1022 682h34v34h-34zM70 716h34v34H70z" />
      <path fill="#fff" d="M104 716h34v34h-34z" />
      <path fill="#0d4029" d="M138 716h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M206 716h34v34h-34z" />
      <path fill="#0d4029" d="M240 716h34v34h-34z" />
      <path fill="#fff" d="M274 716h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M308 716h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#fff"
        d="M478 716h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M614 716h34v34h-34z" />
      <path fill="#fff" d="M648 716h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M716 716h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#fff"
        d="M818 716h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M70 750h34v34H70z" />
      <path fill="#fff" d="M104 750h34v34h-34z" />
      <path fill="#0d4029" d="M138 750h34v34h-34z" />
      <path fill="#fff" d="M172 750h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M240 750h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M308 750h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M376 750h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M478 750h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M512 750h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M682 750h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M716 750h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M920 750h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M954 750h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#fff"
        d="M70 784h34v34H70zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M342 784h34v34h-34z" />
      <path
        fill="#fff"
        d="M376 784h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M682 784h34v34h-34z" />
      <path fill="#fff" d="M716 784h34v34h-34z" />
      <path fill="#0d4029" d="M750 784h34v34h-34z" />
      <path
        fill="#fff"
        d="M784 784h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M886 784h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#fff"
        d="M954 784h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#0d4029"
        d="M70 818h34v34H70zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M308 818h34v34h-34z" />
      <path fill="#0d4029" d="M342 818h34v34h-34z" />
      <path
        fill="#fff"
        d="M376 818h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M478 818h34v34h-34z" />
      <path fill="#fff" d="M512 818h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M580 818h34v34h-34z" />
      <path
        fill="#fff"
        d="M614 818h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M716 818h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M784 818h34v34h-34z" />
      <path fill="#0d4029" d="M818 818h34v34h-34z" />
      <path fill="#fff" d="M852 818h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M886 818h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M988 818h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M70 852h34v34H70z" />
      <path
        fill="#fff"
        d="M104 852h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M274 852h34v34h-34z" />
      <path fill="#fff" d="M308 852h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M342 852h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#fff"
        d="M478 852h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M580 852h34v34h-34z" />
      <path
        fill="#fff"
        d="M614 852h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M750 852h34v34h-34z" />
      <path
        fill="#fff"
        d="M784 852h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M886 852h34v34h-34z" />
      <path
        fill="#fff"
        d="M920 852h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M1022 852h34v34h-34zM70 886h34v34H70z" />
      <path fill="#fff" d="M104 886h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M138 886h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M240 886h34v34h-34z" />
      <path fill="#0d4029" d="M274 886h34v34h-34z" />
      <path
        fill="#fff"
        d="M308 886h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#0d4029"
        d="M410 886h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M512 886h34v34h-34z" />
      <path fill="#0d4029" d="M546 886h34v34h-34z" />
      <path fill="#fff" d="M580 886h34v34h-34z" />
      <path fill="#0d4029" d="M614 886h34v34h-34z" />
      <path fill="#fff" d="M648 886h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M682 886h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M954 886h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M988 886h34v34h-34zm34 0h34v34h-34zM70 920h34v34H70z"
      />
      <path fill="#fff" d="M104 920h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M138 920h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M240 920h34v34h-34z" />
      <path fill="#0d4029" d="M274 920h34v34h-34z" />
      <path fill="#fff" d="M308 920h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M376 920h34v34h-34z" />
      <path fill="#fff" d="M410 920h34v34h-34z" />
      <path fill="#0d4029" d="M444 920h34v34h-34z" />
      <path fill="#fff" d="M478 920h34v34h-34z" />
      <path fill="#0d4029" d="M512 920h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M580 920h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M614 920h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#fff"
        d="M818 920h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#0d4029"
        d="M920 920h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zM70 954h34v34H70z"
      />
      <path fill="#fff" d="M104 954h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M138 954h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M240 954h34v34h-34z" />
      <path fill="#0d4029" d="M274 954h34v34h-34z" />
      <path fill="#fff" d="M308 954h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M376 954h34v34h-34z" />
      <path
        fill="#fff"
        d="M410 954h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path
        fill="#0d4029"
        d="M512 954h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M614 954h34v34h-34z" />
      <path fill="#0d4029" d="M648 954h34v34h-34z" />
      <path fill="#fff" d="M682 954h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M750 954h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M1022 954h34v34h-34z" />
      <path fill="#0d4029" d="M70 988h34v34H70z" />
      <path
        fill="#fff"
        d="M104 988h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M274 988h34v34h-34z" />
      <path fill="#fff" d="M308 988h34v34h-34z" />
      <path fill="#0d4029" d="M342 988h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M410 988h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M478 988h34v34h-34z" />
      <path fill="#fff" d="M512 988h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#0d4029" d="M580 988h34v34h-34z" />
      <path
        fill="#fff"
        d="M614 988h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#0d4029" d="M784 988h34v34h-34z" />
      <path fill="#fff" d="M818 988h34v34h-34z" />
      <path fill="#0d4029" d="M852 988h34v34h-34z" />
      <path fill="#fff" d="M886 988h34v34h-34z" />
      <path fill="#0d4029" d="M920 988h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M988 988h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M1022 988h34v34h-34zm-952 34h34v34H70zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M308 1022h34v34h-34z" />
      <path fill="#0d4029" d="M342 1022h34v34h-34z" />
      <path fill="#fff" d="M376 1022h34v34h-34z" />
      <path fill="#0d4029" d="M410 1022h34v34h-34z" />
      <path fill="#fff" d="M444 1022h34v34h-34z" />
      <path
        fill="#0d4029"
        d="M478 1022h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34zm34 0h34v34h-34z"
      />
      <path fill="#fff" d="M750 1022h34v34h-34z" />
      <path fill="#0d4029" d="M784 1022h34v34h-34zm34 0h34v34h-34z" />
      <path fill="#fff" d="M852 1022h34v34h-34z" />
      <path fill="#0d4029" d="M886 1022h34v34h-34z" />
      <path fill="#fff" d="M920 1022h34v34h-34z" />
      <path fill="#0d4029" d="M954 1022h34v34h-34z" />
      <path fill="#fff" d="M988 1022h34v34h-34zm34 0h34v34h-34z" />
      <path
        fill="none"
        d="M0 0h1126v70H0zm0 70h70v986H0zm1056 0h70v986h-70zM0 1056h1126v70H0z"
      />
    </g>
  </svg>
);
